define("shared/components/shared/post/secondary/publishing-method-setup/setup/notification-publish/index", ["exports", "@ember/component", "@glimmer/component", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _component2, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Post::Secondary::PublishingMethodSetup::Setup::Card
    @buttonText={{t "onboarding.side_wiz.general.cards.send_notification_setup"}}
    @content={{t "onboarding.side_wiz.general.cards.send_notification_cont1"}}
    @header={{t "onboarding.side_wiz.general.cards.send_notification"}}
    @onClick={{fn @setPublishingSetupComponent this.notificationPublishComponent}}
    @recommended={{@recommended}}
    @svg={{svg-jar "notification" class="o--icon--md u--m__r__sm"}}
    class={{"qa--setup_notification_btn"}}
    {{track "selected-mobile-manual-publishing-onboarding" "click"}}
  />
  */
  {
    "id": "zVjEvRDl",
    "block": "[[[8,[39,0],[[24,0,\"qa--setup_notification_btn\"],[4,[38,4],[\"selected-mobile-manual-publishing-onboarding\",\"click\"],null]],[[\"@buttonText\",\"@content\",\"@header\",\"@onClick\",\"@recommended\",\"@svg\"],[[28,[37,1],[\"onboarding.side_wiz.general.cards.send_notification_setup\"],null],[28,[37,1],[\"onboarding.side_wiz.general.cards.send_notification_cont1\"],null],[28,[37,1],[\"onboarding.side_wiz.general.cards.send_notification\"],null],[28,[37,2],[[30,1],[30,0,[\"notificationPublishComponent\"]]],null],[30,2],[28,[37,3],[\"notification\"],[[\"class\"],[\"o--icon--md u--m__r__sm\"]]]]],null]],[\"@setPublishingSetupComponent\",\"@recommended\"],false,[\"shared/post/secondary/publishing-method-setup/setup/card\",\"t\",\"fn\",\"svg-jar\",\"track\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/setup/notification-publish/index.hbs",
    "isStrictMode": false
  });
  class NotificationPublishComponent extends _component2.default {
    get notificationPublishComponent() {
      return _constants.NO_PUBLISHING_METHOD_COMPONENTS.NOTIFICATION_PUBLISH_SETUP;
    }
  }
  _exports.default = NotificationPublishComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NotificationPublishComponent);
});